export const jsonld = "http://www.w3.org/ns/json-ld#";
export const jsonsc = "https://www.w3.org/2019/wot/json-schema#";
